/* ============================================================
   HORCERY — Personas accordion: single-open + height animation.
   No-JS: native <details> still opens/closes (instant).
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initPersonas(section) {
    if (!section || section.__hzInit) return;
    section.__hzInit = true;
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-hz-persona]'));

    function wrapOf(item) { return item.querySelector('.hz-personas__panelwrap'); }

    function open(item) {
      var wrap = wrapOf(item);
      item.open = true;
      if (reduce) { wrap.style.height = 'auto'; return; }
      var h = wrap.scrollHeight;
      wrap.style.height = '0px';
      requestAnimationFrame(function () {
        wrap.style.transition = 'height 0.42s ' + 'cubic-bezier(0.22,0.61,0.36,1)';
        wrap.style.height = h + 'px';
      });
      wrap.addEventListener('transitionend', function te(e) {
        if (e.propertyName !== 'height') return;
        wrap.style.height = 'auto'; wrap.style.transition = '';
        wrap.removeEventListener('transitionend', te);
      });
    }
    function close(item) {
      var wrap = wrapOf(item);
      if (reduce) { item.open = false; return; }
      var h = wrap.scrollHeight;
      wrap.style.height = h + 'px';
      wrap.style.transition = 'height 0.42s cubic-bezier(0.22,0.61,0.36,1)';
      requestAnimationFrame(function () { wrap.style.height = '0px'; });
      wrap.addEventListener('transitionend', function te(e) {
        if (e.propertyName !== 'height') return;
        item.open = false; wrap.style.height = ''; wrap.style.transition = '';
        wrap.removeEventListener('transitionend', te);
      });
    }

    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) { close(item); }
        else { items.forEach(function (i) { if (i !== item && i.open) close(i); }); open(item); }
      });
    });

    // Auto-close any open persona once the section scrolls out of view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) { items.forEach(function (i) { if (i.open) close(i); }); }
        });
      }, { threshold: 0 });
      io.observe(section);
    }
  }

  function initAll() { document.querySelectorAll('[data-hz-personas]').forEach(initPersonas); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-personas]');
    if (el) { el.__hzInit = false; initPersonas(el); }
  });
})();
